import React, { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { gettime2 } from '../../utils/time'
// import { DatePicker, Switch } from '@nutui/nutui-react';
import { CircleClose } from '@nutui/icons-react';
import '@nutui/nutui-react/dist/style.css'
import './index.css'
import { DatePicker } from 'zarm';
import { Dialog } from '@nutui/nutui-react';
import { getmyevents, getsystemlis, cancle, getopen } from '../../utils/api'
import { any } from 'postmate';
// import '@nutui/nutui-react/dist/styles/theme-dark.scss'

import { modifysdmuser, putsdmuser } from '../../utils/api'
import { divide } from 'lodash';

const y = {
    height: '18px', width: '18px', borderRadius: '9px', backgroundColor: '#fff', margin: '2px'
}
const w = { height: '22px', backgroundColor: '#B1B5C1', width: '44px', borderRadius: '11px' }

const y2 = {
    height: '18px', width: '18px', borderRadius: '9px', backgroundColor: '#fff', margin: '2px',
}
const w2 = {
    height: '22px', backgroundColor: '#26ab50', width: '44px', borderRadius: '11px', display: 'flex', flexDirection: 'row', justifyContent: 'end'
}




const blue = {
    borderLeft: '10px solid #4AABEC',
    color: '#4AABEC',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'

}

const pink = {
    borderLeft: '10px solid #E21CAE',
    color: '#E21CAE',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}

const green = {
    borderLeft: '10px solid #6AEC87',
    color: '#6AEC87',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const yellow = {
    borderLeft: '10px solid #FFC932',
    color: '#FFC932',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}
const orange = {
    borderLeft: '10px solid #FD8B86',
    color: '#FD8B86',
    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
}





const MyEvents: React.FC = () => {
    const { t } = useTranslation()

    const [upcoming, getupcoming] = useState([]) as any;
    const [search, setsearch] = useSearchParams()
    const [ids, setids] = useState(search.get("id"));
    const [myeventsdata, getmyeventsdata] = useState([{
        dictValue: '',
        dictLabel: ''
    }]);
    const [typeData, gettypeData] = useState([]);
    const [tabSelected, getSelected] = useState(true);

    const [show, setshow] = useState(false);

    const goBackPage = () => {
        window.history.back()
    }





    const getDate = (data: any, time?: any) => {
        getmyevents({
            sdmId: ids,
            date: time
        }).then((res) => {
            const distance: any = []
            if (data)
                data.forEach((item: any) => {
                    res.rows.forEach((item2: any) => {
                        if (item2.eventType == item.dictValue) {
                            item2.status = item.dictLabel
                        }
                        item2.childEvents.forEach((item3: any) => {
                            if (item3.eventType == item.dictValue) {
                                item3.status = item.dictLabel
                            }

                        })
                    })
                });

            let color = ['4AABEC', 'E21CAE', 'FD8B86', 'FD8D10', 'FFC932', '6AEC87', '76A534', '9F6FFF', 'E97190', '7483C4']
            res.rows.forEach((item2: any, index: number) => {

                item2.eventcolors = color[Number(item2.eventType) - 1]
                item2.childEvents.forEach((item3: any) => {
                    item3.eventcolors = color[Number(item3.eventType) - 1]
                })


                if (index != 0) {
                    res.rows[index - 1].distance = getDistances(item2.latitude, item2.longitude, res.rows[index - 1].latitude, res.rows[index - 1].longitude)
                    // a = item2
                    // a.childEvents = null

                    // item2.childEvents.push(item2)
                    // console.log(a,111)
                }
            })
            res.rows.forEach((item: any) => {
                item.time = gettime2(item.eventStartTime, item.eventEndTime)
                item.childEvents.forEach((item2: any) => {
                    item2.time = gettime2(item2.eventStartTime, item2.eventEndTime)
                })

                if (item.childEvents.length > 0) {
                    let a: any = {
                        eventCountry: item.eventCountry,
                        eventEndTime: item.eventEndTime,
                        eventId: item.eventId,
                        eventLocation: item.eventLocation,
                        eventName: item.eventName,
                        eventType: item.eventType,
                        eventStartTime: item.eventStartTime,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        time: item.time,
                        status: item.status,
                    }
                    item.childEvents.push(a)
                }

            });

            console.log(res.rows)
            getupcoming(res.rows)
            setshow(true)
        }
        );
    }


    const systemlis = async () => {
        await getsystemlis('sys_event_status').then((res) => {
            gettypeData(res.data)
            getDate(res.data)
        }
        );
    }

    const cancel = (id: any) => {
        Dialog.alert({
            content: t('Whethertocancel'),
            confirmText: 'confirm',
            cancelText: 'cancel',
            onConfirm: (e) => {
                cancle({
                    sdmUserId: ids,
                    eventId: id
                }).then((res) => {
                    //   if(res.code == 200)
                    //   getgo(true)
                    getDate('')
                });
            }
        });

    }

    const getDistances = (lat1: any, lng1: any, lat2: any, lng2: any) => {
        let EARTH_RADIUS = 6378.137;// 地球半径
        let radLat1 = lat1 * Math.PI / 180.0; //lat1 * Math.PI / 180.0=>弧度计算
        let radLat2 = lat2 * Math.PI / 180.0;
        let a = radLat1 - radLat2;
        let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
        let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
        s = s * EARTH_RADIUS;
        s = Math.round(s * 10000) / 10000;// 输出为公里
        return Number(s.toFixed(2))
    }

    const [sdmUserId, setsdmUserId] = useState('');
    let sdmUserIdref = useRef('')
    useEffect(() => {
        sdmUserIdref.current = sdmUserId
    }, [sdmUserId])


    useEffect(() => {
        let data3: any = []
        data3 = localStorage.getItem('userinformation')
        data3 = JSON.parse(data3)
        sdmUserIdref.current = data3.userId

        window.scrollTo(0, 0);
        setshow(false)
        getopens()


    }, []);


    const [opens, setopens] = useState('Yse');

    const getopens = async () => {
        await getopen({ sdmUserId: ids }).then((res) => {
            setopens(res.msg)
            if (res.msg == 'Yes') {
                systemlis()
            }

        }
        );
    }


    const newDate = (time: any) => {
        let date = new Date(time)
        let y = date.getFullYear()
        let m: any = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let d: any = date.getDate()
        d = d < 10 ? '0' + d : d
        return y + '/' + m + '/' + d
    }

    const [desc1, setDesc1] = useState('')
    const confirm1 = (values: (Date)) => {

        console.log(values, 9999)
        let option = newDate(values)

        setDesc1(option)
        console.log(option, 9999)
        getDate(typeData, option)
        // setShow1(false)
    }

    const disclosureinformation = () => {

        if (tabSelected) {
            getuser2(0)
            getSelected(false)
        } else {
            getuser2(1)
            getSelected(true)
        }
    }

    const getuser = () => {
        modifysdmuser(ids).then((res) => {
            if (res.data.eventOpen == 1) {
                getSelected(true)
            } else {
                getSelected(false)
            }
        });
    }

    const [currentDateTime, setCurrentDateTime] = useState(new Date());

    const [value, setValue] = useState() as any

    const getuser2 = (n: number) => {
        putsdmuser({
            sdmUserId: ids,
            eventOpen: n
        }).then((res) => {
            console.log(res)

        });
    }
    return <div style={{ backgroundColor: '#202225' }}>
        <div style={{
            width: '100%', height: '60px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
            borderBottomColor: '#4747474D', borderBottomWidth: 1, cursor: 'pointer'
        }}>
            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '20px', alignItems: 'center' }}>
                <img src={require("../../static/img/xljt.png")} style={{ width: '24px', height: '24px', marginRight: '10px' }} onClick={() => goBackPage()}></img>
                <div style={{ lineHeight: '60px', fontSize: '18px', fontWeight: 500, color: '#fff' }}>Test viewing other people's activities</div>
            </div>

            {/* <div style={{ display: 'flex', flexDirection: 'row', marginRight: '20px', alignItems: 'center' }}>
                <div style={{ lineHeight: '60px', fontSize: '12px', fontWeight: 400, color: '#BABBBE', marginRight: '10px' }}>{t('MakeMyEventsPublic')}</div>


                <div style={tabSelected ? w : w2} onClick={() => disclosureinformation()}>
                    <div style={tabSelected ? y : y2}></div>
                </div>
            </div> */}
        </div>
        {
            show&&  <div>
            {
                opens == 'Yes' ? <div>
                    <div style={{ alignItems: 'center', margin: '20px' }}>
                        <div style={{ width: '100%', height: '48px', backgroundColor: '#15161B', borderRadius: '10px', position: 'relative', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                            <input type="text" style={{
                                flex: 1, height: '48px', backgroundColor: '#15161B', borderRadius: 5, display: 'flex',
                                color: '#fff', lineHeight: '40px', marginLeft: 10, fontSize: '14px', border: 'none', paddingLeft: '20px', cursor: 'pointer'
                            }} placeholder='search' value={desc1} />
                            {desc1 &&
                                <CircleClose onClick={() => { setDesc1(''); systemlis() }} color='#666666' style={{ width: '16px', height: '16px', alignSelf: 'center', position: 'absolute', right: '50px' }} />
                            }

                            <img src={require("../../static/img/Date.png")} style={{ width: '22px', height: '22px', alignSelf: 'center', position: 'absolute', right: '20px' }}
                                onClick={async () => {
                                    const { value: changedValue } = await DatePicker.prompt({
                                        defaultValue: currentDateTime,
                                    });
                                    if (!changedValue) return;
                                    confirm1(changedValue)
                                }}></img>
                        </div>
                    </div>

                    <div style={{ alignItems: 'center', width: '100%', zIndex: 1001, borderTopRightRadius: '30px', borderTopLeftRadius: '20px' }}>
                        <div>
                            {
                                upcoming.length > 0 ? <div>
                                    {
                                        upcoming.map((item: any, index: any) =>
                                            <div key={index} >

                                                <div style={{
                                                    borderLeft: '10px solid',
                                                    borderLeftColor: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'),
                                                    color: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'),
                                                    backgroundColor: '#46474F', borderRadius: '10px', padding: '10px', marginLeft: '20px', marginRight: '20px', marginBottom: '10px'
                                                }}>
                                                    <Link to={`/eventdetails?eventId=${item.eventId}&country=${item.country}`
                                                    }
                                                        style={{ color: '#FFF', textDecorationLine: 'none' }}

                                                    >
                                                        <div style={{ margin: 10, display: 'flex', flexDirection: 'row' }}>
                                                            <div style={{
                                                                fontSize: '12px', lineHeight: '14px', height: '14px',
                                                                fontWeight: 500, marginRight: '10px', color: '#ffF'
                                                            }}>
                                                                {item.time}
                                                            </div>
                                                            <div style={{ color: (item.eventcolors ? '#' + item.eventcolors : '#E21CAE'), fontSize: '12px', lineHeight: '14px', height: '14px', fontWeight: 500 }}>{item.status}</div>
                                                        </div>
                                                        <div style={{
                                                            fontSize: '16px', lineHeight: '19px', height: '19px', fontWeight: 600, color: '#ffF', marginLeft: '10px',
                                                            overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '50vw'
                                                        }}>
                                                            {item.eventName}
                                                        </div>
                                                    </Link>
                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', }}>
                                                        {
                                                            item.childEvents.length == 0 ?
                                                                <Link to={{ pathname: '/plat/' + JSON.stringify(item) }}
                                                                    style={{ color: '#FFF', textDecorationLine: 'none' }}
                                                                >

                                                                    <div style={{ display: 'flex', flexDirection: 'row', margin: 10, height: '14px' }}>

                                                                        <img src={require("../../static/img/ph_map-pin.png")} style={{ width: '14px', height: '14px', justifyContent: 'center' }}></img>
                                                                        <div style={{
                                                                            fontSize: '12px', lineHeight: '14px', fontWeight: 500, color: '#BCAFFF', marginLeft: '5px', borderColor: '#BCAFFF',
                                                                            borderBottomWidth: 1, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '50vw', textDecoration: 'underline'

                                                                        }}>
                                                                            {item.eventLocation}
                                                                        </div>
                                                                    </div>
                                                                </Link> :
                                                                // <Link to={{ pathname: '/plat/' + JSON.stringify(item) }}

                                                                // <Link to={`/plat3?data=${JSON.stringify(item.childEvents)}&item=${JSON.stringify(item)}`}
                                                                <Link to={`/plat3?name=${item.eventName}&latitude=${item.latitude}&longitude=${item.longitude}`}

                                                                    style={{ color: '#FFF', textDecorationLine: 'none' }}
                                                                >

                                                                    <div style={{ display: 'flex', flexDirection: 'row', margin: 10, height: '14px' }}>

                                                                        <img src={require("../../static/img/ph_map-pin.png")} style={{ width: '14px', height: '14px', justifyContent: 'center' }}></img>
                                                                        <div style={{
                                                                            fontSize: '12px', lineHeight: '14px', fontWeight: 500, color: '#BCAFFF', marginLeft: '5px', borderColor: '#BCAFFF',
                                                                            borderBottomWidth: 1, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '50vw', textDecoration: 'underline'

                                                                        }}>
                                                                            {item.eventLocation}
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                        }

                                                        {/* <div style={{
                                            height: '24px', lineHeight: '14px', width: '57px', textAlign: 'center',
                                            color: '#fff', backgroundColor: '#FFFFFF4D', borderRadius: '12px', fontSize: '12px', padding: '5px', margin: '6px  9px 8px 9px', cursor: 'pointer'
                                        }} onClick={() =>
                                            cancel(item.eventId)
                                        }>
                                            {t('Cancel')}
                                        </div> */}
                                                    </div>

                                                </div>

                                                <div>
                                                    {item.childEvents.length != 0 &&
                                                        <div style={{ paddingRight: '20px', paddingLeft: '20px' }}>
                                                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', backgroundColor: '#303136', margin: '5px', borderRadius: '8px', justifyContent: 'space-between' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                                    <img src={require("../../static/img/maki_caution.png")} style={{ width: '16px', height: '16px', alignSelf: 'center', marginLeft: '20px', marginRight: '10px' }} ></img>
                                                                    <div style={{ lineHeight: '32px', color: '#BABBBE', fontSize: '12px', fontWeight: 400, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '55vw' }}>{t('Therearemultipleeventsinthisperiod')}</div>
                                                                </div>
                                                                {/* plat2?longitude=${item.longitude}&latitude=${item.latitude} */}
                                                                {/* <Link to={{ pathname: '/conflictEvents/' + JSON.stringify(item) }} */}
                                                                {/* <Link to={{ pathname: '/conflictEvents/' + item.eventId }} */}
                                                                <Link to={`/conflictEvents2?eventId=${item.eventId}&time=${desc1}&ids=${ids}`}
                                                                    style={{ color: '#FFF', textDecorationLine: 'none' }}
                                                                >
                                                                    <div style={{ lineHeight: '32px', width: '44px', color: '#D79E0D', fontSize: '12px', fontWeight: 600, marginRight: '20px' }}>{t('Viewall')}</div>
                                                                </Link>

                                                            </div>
                                                        </div>
                                                    }
                                                    {index != upcoming.length - 1 &&
                                                        <div style={{
                                                            display: 'flex', flexDirection: 'row', marginTop: '10px', marginLeft: '50px', marginBottom: '10px', marginRight: '50px',
                                                            textAlign: 'left'
                                                        }}>
                                                            <div style={{ marginRight: '10px' }}>
                                                                <div style={{ height: 6, width: 6, backgroundColor: '#38CA9F', borderRadius: '3px', marginTop: '-2.5px' }}></div>
                                                                <div style={{ height: '90%', borderLeft: '1px dashed #38CA9F', marginLeft: '2px' }}></div>
                                                                <div style={{ height: 6, width: 6, backgroundColor: '#38CA9F', borderRadius: '3px', marginTop: '-2.5px' }}></div>
                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                {
                                                                    upcoming[index].eventCountry != upcoming[index + 1].eventCountry && <div style={{ color: '#38CA9F', textAlign: 'center', margin: '5px', fontSize: '12px', flexWrap: 'wrap' }}>
                                                                        {t('InternationalTravelPlanyouritinerarywell')}
                                                                    </div>
                                                                }


                                                                <div style={{ color: '#ccc', fontSize: '12px', paddingLeft: '70px', }}>
                                                                    {t('Distance')}:<span style={{ fontSize: '18px', marginLeft: '5px', marginRight: '5px', fontWeight: 700 }}>{item.distance}</span>km

                                                                </div>
                                                            </div>

                                                        </div>}

                                                </div>
                                            </div>

                                        )
                                    }
                                </div> : <div style={{ color: '#fff', textAlign: 'center', marginTop: '20px', fontSize: '16px' }}>
                                    {t('Notcurrentlyparticipatinginactivities')}
                                </div>
                            }
                        </div>


                    </div>
                </div> : <div style={{ color: '#fff', textAlign: 'center', marginTop: '20px', fontSize: '16px' }}>
                    {t('Theeventhasnotbeenmadepublicyet')}
                </div>
            }
        </div>
        }
 


    </div>
};






export default MyEvents;